import { Sun, Moon } from 'lucide-react';
import { Icon } from '@components/base/display';
import { Button } from '@components/base/actions';

interface ThemeToggleProps {
  isDarkMode: boolean;
  onToggle: () => void;
}

export function ThemeToggle({ isDarkMode, onToggle }: Readonly<ThemeToggleProps>) {
  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={onToggle}
      aria-label={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      {isDarkMode ? <Icon icon={Sun} /> : <Icon icon={Moon} />}
    </Button>
  );
}
